function formatLocalDate(date) {
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");
}

const filterEventsByDate = (d, selectedDate) => {
  // const date = d.session_datetime.substring(0, 10);
  const date = new Date(d.session_datetime).toLocaleDateString();
  // const selectedDateString = formatLocalDate(selectedDate);
  const selectedDateString = new Date(selectedDate).toLocaleDateString();
  return date === selectedDateString;
};

// On empêche la requête si les séances de ce jour ont déjà été fetch
const areEventsFetched = (events, date) =>
  events.filter((d) => filterEventsByDate(d, date)).length > 0;

// On empêche la requête s'il n'y a pas d'icônes de séances ce jour
const areEventsNotScheduled = (
  isFulfilled,
  iconSessions,
  iconCompetitions,
  date
) =>
  isFulfilled && // pour ça, la requête pour get les icônes doit être terminée et réussie
  !iconSessions?.[formatLocalDate(date)] &&
  !iconCompetitions?.[formatLocalDate(date)];

export { filterEventsByDate, areEventsFetched, areEventsNotScheduled };
